import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';
import { upperFirst } from 'lodash';

import { StandardCost } from 'bom/elements';
import { BomPartHelper } from 'bom/helpers';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Price } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { PricingHelper } from 'pricing/helpers';

interface IProps extends ICellRendererParams {
  type: string;
  columnId: string;
  costDecimals?: number;
}

export const PnbPricingCell = ({
  type = 'base',
  columnId,
  costDecimals = PricingHelper.DEFAULT_COST_DECIMALS,
  ...rest
}: IProps) => {
  const data = getAgGridTableCellData(rest, columnId);

  if (!data) {
    return rest?.value;
  }

  const getCostingValues = () => {
    const propType = upperFirst(type);

    return {
      computedCost: data[`computedCost${propType}`],
      computedPurchaseCost: data[`computedPurchaseCost${propType}`],
    };
  };

  const { computedCost, computedPurchaseCost } = getCostingValues();

  if (!BomPartHelper.isBaseAdderPnbPricingEnabled(data)) {
    return DEFAULT_PLACEHOLDER;
  }

  return (
    <Stack>
      <StandardCost
        cost={computedCost}
        decimals={costDecimals}
        fixedDecimals
        label={`${t('labelStandardCost')}:`}
      />

      <Price
        amount={computedPurchaseCost}
        decimals={costDecimals}
        fixedDecimals
        label={`${t('labelPurchaseCost')}:`}
      />
    </Stack>
  );
};
